module.exports = __webpack_public_path__ + "img/znywfw.3feb967a.png";